import { render, staticRenderFns } from "./InputMinusPlus.vue?vue&type=template&id=a061d484&scoped=true&"
import script from "./InputMinusPlus.vue?vue&type=script&lang=js&"
export * from "./InputMinusPlus.vue?vue&type=script&lang=js&"
import style0 from "./InputMinusPlus.vue?vue&type=style&index=0&id=a061d484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a061d484",
  null
  
)

export default component.exports